import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=864a7fd8&scoped=true&"
import script from "./TheHeader.vue?vue&type=script&lang=js&"
export * from "./TheHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=864a7fd8&scoped=true&lang=css&"
import style1 from "./TheHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864a7fd8",
  null
  
)

export default component.exports